// The Company ID people sign in with, remembered on this device after a
// sign-in or sign-up so they only have to type it once.
const KEY = 'asys-retail:company-id'

export function rememberedCompanyId() {
  try {
    return window.localStorage.getItem(KEY) || ''
  } catch {
    return ''
  }
}

export function rememberCompanyId(id) {
  try {
    if (id != null && String(id).trim()) window.localStorage.setItem(KEY, String(id).trim())
  } catch {
    // Storage can be blocked (private windows); signing in still works.
  }
}

/** A Company ID as typed, or an error message if it isn't a whole number. */
export function parseCompanyId(text) {
  const t = String(text || '').trim()
  if (!t) return { error: 'Enter your Company ID.' }
  const n = Number(t)
  if (!Number.isInteger(n) || n <= 0) return { error: 'Your Company ID is a whole number, like 12.' }
  return { id: n }
}
